<div class="dashboard-content">
    <ng-container *ngFor="let url of HTML_arrayDashbordIMG">
        <div class="dashboard-element">
            <ng-container *ngIf="HTML_arrayDashbordIMG; else elseTemplate">
                <img class="block-img" [ngClass]="getNgClassStyleColor" [src]="url" alt="Report">
            </ng-container>
            <ng-template #elseTemplate>
                <mat-spinner></mat-spinner>
            </ng-template>
        </div>
    </ng-container>
</div>